import React from 'react'
import { Theme, useTheme } from '@mui/material'

interface IIconProps {
  width?: string
}

const BetterSecondSessionIcon: React.FC<IIconProps> = (props) => {
  const theme: Theme = useTheme()
  return (
    <svg
      viewBox='0 0 48 48' fill={theme.palette.text.primary}
      height={props.width} width={props.width} xmlns='http://www.w3.org/2000/svg'
    >
      <g id='Icons'>
        <rect height='14' rx='1' width='12' x='4' y='28' />
        <rect height='20' rx='1' width='12' x='18' y='22' />
        <rect height='26' rx='1' width='12' x='32' y='16' />
        <path
          d='m45.788 2.385a1 1 0 0 0 -.788-.385h-8a1 1 0 0 0 0 2h5.371a75.166 75.166 0 0 1 -18.781 12.088 75.363 75.363 0 0 1 -20.725 5.921 1 1 0 0 0 .135 1.991 1.059 1.059 0 0 0 .136-.009 77.375 77.375 0 0 0 21.274-6.079 77.184 77.184 0 0 0 18.832-12l-1.212 4.85a1 1 0 0 0 .727 1.212 1.025 1.025 0 0 0 .243.026 1 1 0 0 0 .969-.758l2-8a1 1 0 0 0 -.181-.857z'
        />
        <path d='m45 46h-42a1 1 0 0 1 0-2h42a1 1 0 0 1 0 2z' />
      </g>
    </svg>
  )
}
export default BetterSecondSessionIcon
